// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetPublicCurrency (params?: {}): Promise<Dict>;
    publicGetPublicCurrencyCurrency (params?: {}): Promise<Dict>;
    publicGetPublicSymbol (params?: {}): Promise<Dict>;
    publicGetPublicSymbolSymbol (params?: {}): Promise<Dict>;
    publicGetPublicTicker (params?: {}): Promise<Dict>;
    publicGetPublicTickerSymbol (params?: {}): Promise<Dict>;
    publicGetPublicPriceRate (params?: {}): Promise<Dict>;
    publicGetPublicPriceHistory (params?: {}): Promise<Dict>;
    publicGetPublicPriceTicker (params?: {}): Promise<Dict>;
    publicGetPublicPriceTickerSymbol (params?: {}): Promise<Dict>;
    publicGetPublicTrades (params?: {}): Promise<Dict>;
    publicGetPublicTradesSymbol (params?: {}): Promise<List>;
    publicGetPublicOrderbook (params?: {}): Promise<Dict>;
    publicGetPublicOrderbookSymbol (params?: {}): Promise<Dict>;
    publicGetPublicCandles (params?: {}): Promise<Dict>;
    publicGetPublicCandlesSymbol (params?: {}): Promise<List>;
    publicGetPublicConvertedCandles (params?: {}): Promise<Dict>;
    publicGetPublicConvertedCandlesSymbol (params?: {}): Promise<List>;
    publicGetPublicFuturesInfo (params?: {}): Promise<Dict>;
    publicGetPublicFuturesInfoSymbol (params?: {}): Promise<Dict>;
    publicGetPublicFuturesHistoryFunding (params?: {}): Promise<Dict>;
    publicGetPublicFuturesHistoryFundingSymbol (params?: {}): Promise<List>;
    publicGetPublicFuturesCandlesIndexPrice (params?: {}): Promise<Dict>;
    publicGetPublicFuturesCandlesIndexPriceSymbol (params?: {}): Promise<List>;
    publicGetPublicFuturesCandlesMarkPrice (params?: {}): Promise<Dict>;
    publicGetPublicFuturesCandlesMarkPriceSymbol (params?: {}): Promise<List>;
    publicGetPublicFuturesCandlesPremiumIndex (params?: {}): Promise<Dict>;
    publicGetPublicFuturesCandlesPremiumIndexSymbol (params?: {}): Promise<List>;
    publicGetPublicFuturesCandlesOpenInterest (params?: {}): Promise<Dict>;
    publicGetPublicFuturesCandlesOpenInterestSymbol (params?: {}): Promise<List>;
    privateGetSpotBalance (params?: {}): Promise<Dict>;
    privateGetSpotBalanceCurrency (params?: {}): Promise<Dict>;
    privateGetSpotOrder (params?: {}): Promise<List>;
    privateGetSpotOrderClientOrderId (params?: {}): Promise<Dict>;
    privateGetSpotFee (params?: {}): Promise<List>;
    privateGetSpotFeeSymbol (params?: {}): Promise<Dict>;
    privateGetSpotHistoryOrder (params?: {}): Promise<List>;
    privateGetSpotHistoryTrade (params?: {}): Promise<List>;
    privateGetMarginAccount (params?: {}): Promise<List>;
    privateGetMarginAccountIsolatedSymbol (params?: {}): Promise<Dict>;
    privateGetMarginAccountCrossCurrency (params?: {}): Promise<List>;
    privateGetMarginOrder (params?: {}): Promise<List>;
    privateGetMarginOrderClientOrderId (params?: {}): Promise<Dict>;
    privateGetMarginConfig (params?: {}): Promise<Dict>;
    privateGetMarginHistoryOrder (params?: {}): Promise<List>;
    privateGetMarginHistoryTrade (params?: {}): Promise<List>;
    privateGetMarginHistoryPositions (params?: {}): Promise<List>;
    privateGetMarginHistoryClearing (params?: {}): Promise<List>;
    privateGetMarginSettings (params?: {}): Promise<Dict>;
    privateGetFuturesBalance (params?: {}): Promise<Dict>;
    privateGetFuturesBalanceCurrency (params?: {}): Promise<Dict>;
    privateGetFuturesAccount (params?: {}): Promise<List>;
    privateGetFuturesAccountIsolatedSymbol (params?: {}): Promise<Dict>;
    privateGetFuturesOrder (params?: {}): Promise<List>;
    privateGetFuturesOrderClientOrderId (params?: {}): Promise<Dict>;
    privateGetFuturesConfig (params?: {}): Promise<Dict>;
    privateGetFuturesFee (params?: {}): Promise<List>;
    privateGetFuturesFeeSymbol (params?: {}): Promise<Dict>;
    privateGetFuturesHistoryOrder (params?: {}): Promise<List>;
    privateGetFuturesHistoryTrade (params?: {}): Promise<List>;
    privateGetFuturesHistoryPositions (params?: {}): Promise<List>;
    privateGetFuturesHistoryClearing (params?: {}): Promise<List>;
    privateGetUserApiKeys (params?: {}): Promise<List>;
    privateGetWalletBalance (params?: {}): Promise<Dict>;
    privateGetWalletBalanceCurrency (params?: {}): Promise<Dict>;
    privateGetWalletCryptoAddressWhiteList (params?: {}): Promise<Dict>;
    privateGetWalletCryptoAddress (params?: {}): Promise<List>;
    privateGetWalletCryptoAddressRecentDeposit (params?: {}): Promise<List>;
    privateGetWalletCryptoAddressRecentWithdraw (params?: {}): Promise<List>;
    privateGetWalletCryptoAddressCheckMine (params?: {}): Promise<Dict>;
    privateGetWalletTransactions (params?: {}): Promise<List>;
    privateGetWalletTransactionsTxId (params?: {}): Promise<Dict>;
    privateGetWalletCryptoFeeEstimate (params?: {}): Promise<Dict>;
    privateGetWalletCryptoFeeWithdrawHash (params?: {}): Promise<Dict>;
    privateGetWalletAirdrops (params?: {}): Promise<List>;
    privateGetWalletAmountLocks (params?: {}): Promise<List>;
    privateGetSubAccount (params?: {}): Promise<List>;
    privateGetSubAccountAcl (params?: {}): Promise<List>;
    privateGetSubAccountBalanceSubAccID (params?: {}): Promise<Dict>;
    privateGetSubAccountCryptoAddressSubAccIDCurrency (params?: {}): Promise<Dict>;
    privatePostSpotOrder (params?: {}): Promise<Dict>;
    privatePostSpotOrderList (params?: {}): Promise<List>;
    privatePostMarginOrder (params?: {}): Promise<Dict>;
    privatePostMarginOrderList (params?: {}): Promise<List>;
    privatePostFuturesOrder (params?: {}): Promise<Dict>;
    privatePostFuturesOrderList (params?: {}): Promise<List>;
    privatePostWalletCryptoAddress (params?: {}): Promise<Dict>;
    privatePostWalletCryptoWithdraw (params?: {}): Promise<Dict>;
    privatePostWalletConvert (params?: {}): Promise<List>;
    privatePostWalletTransfer (params?: {}): Promise<Dict>;
    privatePostWalletInternalWithdraw (params?: {}): Promise<Dict>;
    privatePostWalletCryptoCheckOffchainAvailable (params?: {}): Promise<Dict>;
    privatePostWalletCryptoFeesEstimate (params?: {}): Promise<List>;
    privatePostWalletCryptoFeeEstimateBulk (params?: {}): Promise<List>;
    privatePostWalletAirdropsIdClaim (params?: {}): Promise<Dict>;
    privatePostSubAccountFreeze (params?: {}): Promise<Dict>;
    privatePostSubAccountActivate (params?: {}): Promise<Dict>;
    privatePostSubAccountTransfer (params?: {}): Promise<Dict>;
    privatePostSubAccountTransferSubToSuper (params?: {}): Promise<Dict>;
    privatePostSubAccountTransferSubToSub (params?: {}): Promise<Dict>;
    privatePostSubAccountAcl (params?: {}): Promise<List>;
    privatePatchSpotOrderClientOrderId (params?: {}): Promise<Dict>;
    privatePatchMarginOrderClientOrderId (params?: {}): Promise<Dict>;
    privatePatchFuturesOrderClientOrderId (params?: {}): Promise<Dict>;
    privateDeleteSpotOrder (params?: {}): Promise<List>;
    privateDeleteSpotOrderClientOrderId (params?: {}): Promise<Dict>;
    privateDeleteMarginPosition (params?: {}): Promise<List>;
    privateDeleteMarginPositionIsolatedSymbol (params?: {}): Promise<Dict>;
    privateDeleteMarginOrder (params?: {}): Promise<List>;
    privateDeleteMarginOrderClientOrderId (params?: {}): Promise<Dict>;
    privateDeleteFuturesPosition (params?: {}): Promise<List>;
    privateDeleteFuturesPositionMarginModeSymbol (params?: {}): Promise<Dict>;
    privateDeleteFuturesOrder (params?: {}): Promise<List>;
    privateDeleteFuturesOrderClientOrderId (params?: {}): Promise<Dict>;
    privateDeleteWalletCryptoWithdrawId (params?: {}): Promise<Dict>;
    privatePutMarginAccountIsolatedSymbol (params?: {}): Promise<Dict>;
    privatePutMarginSettingsAmm (params?: {}): Promise<Dict>;
    privatePutMarginMarginSettingsAmr (params?: {}): Promise<Dict>;
    privatePutFuturesAccountIsolatedSymbol (params?: {}): Promise<Dict>;
    privatePutFuturesMarginSettingsAmr (params?: {}): Promise<Dict>;
    privatePutWalletCryptoWithdrawId (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
